// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"h6-z"};